export interface IGuiaSeguroState {
    esSeguroBasico: boolean;
    esSeguroMercancia: boolean;
    valorMercancia?: number | null;
}

export function validarSeguroGuia(
    state: IGuiaSeguroState,
    valorMinimo: number,
    valorMaximo: number,
    esExcluirSeguro: boolean
): boolean {
    if (state.esSeguroBasico) {
        return true;
    }

    if (state.esSeguroMercancia) {
        const valor = state.valorMercancia;
        return valor != null
            && !Number.isNaN(valor)
            && valor > 0
            && valor >= valorMinimo
            && valor <= valorMaximo;
    }

    return !state.esSeguroBasico
        && !state.esSeguroMercancia
        && esExcluirSeguro;
}

export type ResultadoValidacionSeguroGuia =
    | { tipo: 'valido' }
    | { tipo: 'requerido' }
    | { tipo: 'fuera_rango'; direccion: 'min' | 'max' }
    | { tipo: 'sin_seguro' };

export function evaluarSeguroGuia(
    state: IGuiaSeguroState,
    valorMinimo: number,
    valorMaximo: number,
    esExcluirSeguro: boolean
): ResultadoValidacionSeguroGuia {
    if (validarSeguroGuia(state, valorMinimo, valorMaximo, esExcluirSeguro)) {
        return { tipo: 'valido' };
    }

    if (state.esSeguroMercancia) {
        const valor = state.valorMercancia;
        if (valor == null || Number.isNaN(valor) || valor <= 0) {
            return { tipo: 'requerido' };
        }
        if (valor < valorMinimo) {
            return { tipo: 'fuera_rango', direccion: 'min' };
        }
        if (valor > valorMaximo) {
            return { tipo: 'fuera_rango', direccion: 'max' };
        }
        return { tipo: 'requerido' };
    }

    if (!state.esSeguroBasico && !state.esSeguroMercancia) {
        return { tipo: 'sin_seguro' };
    }

    return { tipo: 'sin_seguro' };
}
